import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/styles'
import { ButtonBase } from '@material-ui/core'
import ListIcon from 'components/common/icons/List'
import ScanFeedToggle from 'components/common/icons/ScanFeedToggle'
import { trackEvent } from 'utils/analyticsUtils'

const useStyles = makeStyles(theme => ({
  toggleWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'fit-content',
    minWidth: 0,
    background: 'rgba(65, 81, 230, 0.12)',
    borderRadius: 6,
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    padding: '1px 2px',
    margin: '4px 12px 12px 12px',
    gap: 2
  },
  iconButton: {
    borderRadius: 4,
    padding: 0,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s',
    background: 'transparent',
    '&:hover': {
      background: 'rgba(65, 81, 230, 0.08)'
    }
  },
  active: {
    background: 'transparent'
  }
}))

const TimelineViewToggle = ({ isScanFeed, onShowMainFeed, onShowScanFeed }) => {
  const classes = useStyles()
  const activeColor = '#4151E6'
  const inactiveColor = '#C2C2C2'
  const iconSize = 24

  const handleShowMainFeed = useCallback(() => {
    trackEvent('Timeline toggle clicked - main feed')
    onShowMainFeed()
  }, [onShowMainFeed])

  const handleShowScanFeed = useCallback(() => {
    trackEvent('Timeline toggle clicked - scan feed')
    onShowScanFeed()
  }, [onShowScanFeed])

  return (
    <div className={classes.toggleWrapper}>
      <ButtonBase
        id="timeline-view-toggle-main-feed"
        className={`${classes.iconButton} ${!isScanFeed ? classes.active : ''}`}
        onClick={handleShowMainFeed}
        aria-label="Show Main Feed"
        disabled={!isScanFeed}
      >
        <ListIcon
          color={!isScanFeed ? activeColor : inactiveColor}
          style={{
            fontSize: iconSize,
            width: iconSize,
            height: iconSize
          }}
        />
      </ButtonBase>
      <ButtonBase
        id="timeline-view-toggle-scan-feed"
        className={`${classes.iconButton} ${isScanFeed ? classes.active : ''}`}
        onClick={handleShowScanFeed}
        aria-label="Show Scan Feed"
        disabled={isScanFeed}
      >
        <ScanFeedToggle color={isScanFeed ? activeColor : inactiveColor} size={iconSize} />
      </ButtonBase>
    </div>
  )
}

export default TimelineViewToggle
